/**
 * The name TransectLibre shows for a resource. A person linked to a Microsoft account is shown
 * with the account's display name (Resource.displayName, kept by TransectLibre only); every other
 * resource, and the exchange with ProjectLibre (export, matching on re-import), uses the
 * ProjectLibre resource name.
 */
export interface LabelledResource {
  name: string;
  kind?: string;
  displayName?: string | null;
}

export function resourceLabel(r: LabelledResource): string {
  return r.kind === 'person' && r.displayName ? r.displayName : r.name;
}
